import React from "react";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAbout from "../../components/about/FormAbout";
import { useGetAboutPage } from "../../hooks/about/useGetAboutPage";
import { useUpdateAboutPage } from "../../hooks/about/useUpdateAboutPage";

const AboutPage = () => {
    const { aboutPage, isLoading: isFetching } = useGetAboutPage();
    const { mutate, isPending: isUpdating } = useUpdateAboutPage();

    const handleSubmit = (data) => {
        mutate(data);
    };

    if (isFetching) {
        return null;
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAbout 
                titleAr="صفحة من نحن" 
                titleEn="About Us Page" 
                currentData={aboutPage} 
                onSubmit={handleSubmit} 
                isLoading={isUpdating} 
            />
        </WrapperSection>
    );
};

export default AboutPage;
